import { render, staticRenderFns } from "./FacturaShowDataCustom.vue?vue&type=template&id=2d3cfea2"
import script from "./FacturaShowDataCustom.vue?vue&type=script&lang=js"
export * from "./FacturaShowDataCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports